module.exports = __webpack_public_path__ + "img/sillon-2.ffcdd9bd.jpg";